<script>
  import axios from "axios";
  import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch.vue";
  import {AggregatorPath, BrandsPath, RestaurantsPath, StorePath} from "@/path";
  export default {
    computed: {
      RestaurantsPath() {
        return RestaurantsPath
      },
      BrandsPath() {
        return BrandsPath
      }
    },
    props : ["selectedRestaurant","selectedBrand","selected_store"],
    components : {
      SelectWithSearch,
    },
    data(){
      return {
        selectedOption : null,
        form : {
          platform_data : {},
          timings : []
        },
        aggregators : [],
        timingsData : [
          {
            day : "monday",
            slots : []
          },
          {
            day : "tuesday",
            slots : []
          },
          {
            day : "wednesday",
            slots : []
          },
          {
            day : "thursday",
            slots : []
          },
          {
            day : "friday",
            slots : []
          },
          {
            day : "saturday",
            slots : []
          },
          {
            day : "sunday",
            slots : []
          }
        ],
        days : [
          {
            value : "monday",
            text : "Monday"
          },
          {
            value : "tuesday",
            text : "Tuesday"
          },
          {
            value : "wednesday",
            text : "Wednesday"
          },
          {
            value : "thursday",
            text : "Thursday"
          },
          {
            value : "friday",
            text : "Friday"
          },
          {
            value : "saturday",
            text : "Saturday"
          },
          {
            value : "sunday",
            text : "Sunday"
          }
        ],
        baseUrl : process.env.VUE_APP_API_BACKEND_URL,
        key : 1,
        selected_platforms : []
      }
    },
    mounted() {
      this.getAggregators();
    },
    watch : {
      selected_store(v){
        if(v){
          this.form.restaurant_id = v.restaurant.id;
          this.selectedRestaurant = v.restaurant;
          this.form.brand_id = v.brand.id;
          this.loadStore();
        }else{
          this.form = {
            platform_data : {},
            timings : []
          }
          this.selected_platforms = [];
        }
      }
    },
    methods : {
      addTimings(){
        this.form.timings.push({
          "day": '',
          "slots": []
        });
      },
      selectedOptionRestaurant(v) {
        this.form.restaurant_id = v.id;
        this.form.name = v.name;
        this.key += 1;
      },
      selectedBrandOption(v){
        console.log(v);
        this.form.brand_id = v;
        // this.loadStore();
      },
      async getAggregators(){
        try {
          let res = await axios.get(this.baseUrl + AggregatorPath.getAggregators);
          if(res.data.status){
            this.aggregators = res.data.data;
          }
        }catch (e){
          console.log(e);
        }
      },
      selectedAggregator(v){
        if(v){
          Object.keys(this.form.platform_data)
              .filter(f => !(v.map(vm => vm.text)
                  .includes(f)))
              .forEach(f => {
                delete this.form.platform_data[f];
              });
          v.forEach(d => {
            this.form.platform_data[d.text] = {
              text : d.text,
              url : this.form.platform_data && this.form.platform_data[d.text] ? this.form.platform_data[d.text].url : '',
              store_id : this.form.platform_data && this.form.platform_data[d.text] ? this.form.platform_data[d.text].store_id : "",
              is_enabled : this.form.platform_data && this.form.platform_data[d.text] ? this.form.platform_data[d.text].is_enabled : "",
            };
          });
          this.key += 1;
        }
      },
      async loadStore(){
        try{
          if(this.selectedRestaurant){
            this.form.restaurant_id = this.selectedRestaurant.id;
          }
          if(this.selectedBrand != undefined){
            this.form.brand_id = this.selectedBrand;
          }
          let res = await axios.get(this.baseUrl + StorePath.GET_STORE,{
            params : {
              restaurant_id : this.form.restaurant_id,
              brand_id : this.form.brand_id
            }
          });
          console.log(res.data.status && res.data.data && Object.keys(res.data.data).length > 0);
          if(res.data.status && res.data.data && Object.keys(res.data.data).length > 0) {
            const storeData = res.data.data;
            storeData.hide_from_ui = storeData.hide_from_ui == 1 ? true : false;
            storeData.ordering_enabled = storeData.ordering_enabled == 1 ? true : false;

            // Normalize platform_data keys
            if (storeData.platform_data) {
              const normalized = {};
              Object.keys(storeData.platform_data).forEach(key => {
                let k = key.toLowerCase();
                if (k === 'growthfalcon') k = 'growthfalcons';
                normalized[k] = storeData.platform_data[key];
              });
              storeData.platform_data = normalized;
            }
            this.form = storeData;
            
            this.selected_platforms = this.form.platform_data ? Object.keys(this.form.platform_data) : []
            if(this.selected_platforms.length == 0){
              this.form.platform_data = {};
              this.form.timings = [];
            }
          }else{
            this.form = {
              platform_data : {},
              timings : []
            }
            this.selected_platforms = [];
            this.form.hide_from_ui = false;
            this.form.ordering_enabled = false;
          }
        }catch (e) {
          console.log(e);
          return;
        }
      },
      async createStore(){
        try {
          if(this.selectedRestaurant){
            this.form.restaurant_id = this.selectedRestaurant.id;
          }
          let res = await axios.post(this.baseUrl + StorePath.STORE_SAVE,this.form);
          if(res.data.status){
            this.$bvToast.toast('Successfully added store', {
              title: `Store added`,
              variant: 'success',
              solid: true
            });
            this.$bvModal.hide('bv-add-store');
            this.form = {
              platform_data : {},
              timings : [],
            }
            this.selected_platforms = [];
            this.$emit("reload");
          }
        }catch (e) {
          console.log(e);
        }
      },
      setTimingslots(){
        this.form.timings.push({day : '',slots: []})
      },
      setSlots(ti){
        this.form.timings[ti].slots.push({'start_time' : '','end_time' : ''})
      },
      deleteSlots(ti,si){
        this.form.timings[ti].slots.splice(si,1);
      },
      deleteTimingsslots(ti){
        this.form.timings.splice(ti,1);
      }
    }
  }
</script>
<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Store Pos Id:</label>
          </b-col>
          <b-col sm="12" class="mb-2">
            <b-input v-model="form.ref_id"></b-input>
          </b-col>
          <b-col sm="12">
            <label>Store Urban Piper Id:</label>
          </b-col>
          <b-col sm="12" class="mb-2">
            <b-input v-model="form.store_up_id"></b-input>
          </b-col>
          <b-col sm="12">
            <label>Location name:</label>
          </b-col>
          <b-col sm="12" class="mb-2" :key="key">
            <b-input v-model="form.name"></b-input>
          </b-col>
          <b-col sm="12">
            <label>Restaurant:</label>
          </b-col>
          <b-col sm="12" v-if="selectedRestaurant">
            <p>{{this.selectedRestaurant.name}}</p>
          </b-col>
          <b-col sm="12" v-else>
            <select-with-search :full_object="true" :search_api="RestaurantsPath.GET_RESTAURANTS" track_by="id" display="name" @selectedOption="selectedOptionRestaurant"></select-with-search>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Brand:</label>
          </b-col>
          <b-col sm="12" v-if="selected_store">
            <p>{{this.selected_store.brand.name}}</p>
          </b-col>
          <b-col sm="12" v-else>
            <select-with-search :search_api="BrandsPath.BRAND_SEARCH" display="label" track_by="id" @selectedOption="selectedBrandOption"></select-with-search>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12">
            <label>Include Platform :</label>
          </b-col>
          <b-col sm="12">
            <select-with-search :full_object="true" :selected_data="selected_platforms" selected_by="text" :search_without_api="true" @selectedOption="selectedAggregator" :multi_select="true" track_by="value" display="text" :options-data="aggregators"></select-with-search>
          </b-col>
        </b-row>
        <b-row class="my-1" :key="key">
          <b-col sm="12" v-if="Object.keys(form.platform_data).length > 0">
            <label>Platform Data</label>
          </b-col>
          <b-col sm="12">
            <b-row class="12" v-for="(p,pi) in Object.keys(form.platform_data)" :key="pi">
              <b-col sm="6">
                <label>Name : </label>
                <b-form-input readonly :value="p" v-model="form.platform_data[p].text"></b-form-input>
              </b-col>
              <b-col sm="6">
                <label>Url</label>
                <b-form-input v-model="form.platform_data[p].url"></b-form-input>
              </b-col>
              <b-col sm="12">
                <label>Platform Store Id</label>
                <b-form-input v-model="form.platform_data[p].store_id"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="12"><a href="#" v-b-toggle.optional-fields>Additional Options <i class="fa fa-angle-down"></i></a></b-col>
        </b-row>
        <b-collapse id="optional-fields" class="mt-2">
          <b-row class="my-1">
            <b-col sm="6">
              <label>Min Pickup Time (Sec) :</label>
              <b-form-input v-model="form.min_pickup_time" type="number"></b-form-input>
            </b-col>
            <b-col sm="6">
              <label>Max Pickup Time (Sec):</label>
              <b-form-input v-model="form.max_pickup_time" type="number"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="12">
              <label>Notification Phones :</label>
            </b-col>
            <b-col sm="12">
              <b-form-tags input-id="tags-basic" placeholder="Add phones" v-model="form.notification_phones"></b-form-tags>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="12">
              <label>Notification Emails :</label>
            </b-col>
            <b-col sm="12">
              <b-form-tags input-id="tags-basic" placeholder="Add emails" v-model="form.notification_emails"></b-form-tags>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="12">
              <label>Contact Phone:</label>
            </b-col>
            <b-col sm="12">
              <b-form-input v-model="form.contact_phone"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="12">
              <label>Min Order Value :</label>
            </b-col>
            <b-col sm="12">
              <b-form-input v-model="form.min_order_value"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="6">
              <label>Hide From UI (Urban Priper) :</label>
              <b-form-checkbox v-model="form.hide_from_ui" name="check-button" switch>
              </b-form-checkbox>
            </b-col>
            <b-col sm="6">
              <label>Ordering Enabled (Urban Priper) :</label>
              <b-form-checkbox v-model="form.ordering_enabled" name="check-button" switch></b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="12">
            <b-col sm="12">
              <label class="mr-3">Timings <i v-b-tooltip.hover title="Timings for the store. We support slots based checkout timings" class="fa fa-info-circle"></i>
                <b-button @click="setTimingslots" variant="seconday">
                  <i v-b-tooltip.hover title="Add Time SLots" class="fa fa-plus-square"></i>
                </b-button></label>
            </b-col>
            <b-col sm="12" v-for="(t,ti) in form.timings" :key="ti">
              <b-row class="12 m-3">
                <b-col sm="8">
                  <b-form-select :options="days" v-model="t.day"></b-form-select>
                </b-col>
                <b-col sm="4">
                  <b-button variant="primary" class="mr-3" @click="setSlots(ti)"><i class="fa fa-plus-square"></i></b-button>
                  <b-button variant="danger" @click="deleteTimingsslots(ti)"><i class="fa fa-trash"></i></b-button>
                </b-col>
              </b-row>
              <template v-for="(s,si) in t.slots">
                <b-row class="12 mb-3" :key="si">
                  <b-col sm="5">
                    <b-form-timepicker reset-button locale="en" placeholder="Start Time" v-model="s.start_time"></b-form-timepicker>
                  </b-col>
                  <b-col sm="5">
                    <b-form-timepicker reset-button locale="en" placeholder="End Time" v-model="s.end_time"></b-form-timepicker>
                  </b-col>
                  <b-col sm="2">
                    <i class="fa fa-trash text-danger" @click="deleteSlots(ti,si)"></i>
                  </b-col>
                </b-row>
              </template>
            </b-col>
          </b-row>
        </b-collapse>
        <b-row class="my-1 mt-2">
          <b-col sm="12">
            <b-button @click="createStore" class="btn btn-success">Save</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>